



















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import BaseComponent from '@/core/base.component';
import {
  BaeminReportDto,
  ConsultResponseV3Dto,
  SalesRequestDto,
  SalesResponseDto,
} from '@/dto';
import {
  CONST_KB_MEDIUM_CATEGORY,
  CONST_STORE_TYPE,
  KB_MEDIUM_CATEGORY,
  KB_MEDIUM_CATEGORY_KOREAN,
  STORE_TYPE,
} from '@/services/shared';
import { Component } from 'vue-property-decorator';
import RevenueChart from '../add-on/RevenueChart.vue';
import DoughnutChart from '../add-on/DoughnutChart.vue';
import BarChart from '../add-on/BarChart.vue';
import ProformaCalculator from '../add-on/ProformaCalculator.vue';

import ConsultResponseV3Service from '@/services/pickcook/consult-response-v3.service';
import toast from '../../../../../resources/assets/js/services/toast.js';

@Component({
  name: 'ConsultReportPrint',
  components: {
    RevenueChart,
    DoughnutChart,
    BarChart,
    ProformaCalculator,
  },
})
export default class ConsultReportPrint extends BaseComponent {
  generateReport() {
    window.print();
  }

  private today = new Date();
  private year: number = this.today.getFullYear();
  private month: number = this.today.getMonth() + 1;
  private day: number = this.today.getDate();

  // 사이드 탭
  private activeTab = 'chart';
  private sideNavTabs = [
    {
      id: 'chart',
      name: '상권분석',
      icon: 'chart',
      active: true,
    },
    {
      id: 'delivery',
      name: '배달현황분석',
      icon: 'delivery',
      active: false,
    },
    {
      id: 'files01',
      name: '신규창업자',
      icon: 'files',
      active: false,
    },
    {
      id: 'files02',
      name: '기창업자',
      icon: 'files',
      active: false,
    },
    {
      id: 'calculator',
      name: '상품안내',
      icon: 'calculator',
      active: false,
    },
  ];

  private isLoading = false;

  onSideTabClick(tabId: string): void {
    this.isLoading = true;
    this.activeTab = tabId;
    if (tabId === 'delivery') this.getBaeminData();
    this.goTop();
  }

  // 픽쿡 상품
  private pickcookLite = [
    {
      title: '레시피',
      name: 'recipe',
      items: [
        {
          id: 'recipe01',
          name: '레시피 및 조리영상 제공&물류연결',
          price: 1188000,
        },
      ],
    },
    {
      title: '메뉴교육',
      name: 'menu',
      // type: 'radio',
      items: [
        {
          id: 'menu01',
          name: '현장실습',
          price: 300000,
        },
        {
          id: 'menu02',
          name: '방문교육 (교통비 실비 별도)',
          price: 300000,
        },
      ],
    },
    {
      title: '배달앱관리',
      name: 'delivery_app',
      items: [
        {
          id: 'deliveryApp01',
          name: '배달 앱 등록 (배민, 쿠팡, 요기요 등)',
          price: 100000,
        },
        {
          id: 'deliveryApp02',
          name: '로고, 사진, 브랜드 제공',
          price: 0,
        },
        {
          id: 'deliveryApp03',
          name: '배달앱 컨설팅 (리뷰이벤트, 깃발 등)',
          price: 200000,
        },
      ],
    },
    {
      title: '디자인물',
      name: 'design',
      items: [
        {
          id: 'designApp01',
          name: '스티커, 메모지, 자석전단지',
          price: 100000,
        },
      ],
    },
  ];

  private pickcookPremium = [
    {
      title: '레시피',
      name: 'recipe',
      items: [
        {
          id: 'premium-recipe01',
          name: '레시피 및 조리영상 제공&물류연결',
          price: 1188000,
        },
      ],
    },
    {
      title: '메뉴교육',
      name: 'menu',
      // type: 'radio',
      items: [
        {
          id: 'premium-menu01',
          name: '현장실습',
          price: 300000,
        },
        {
          id: 'premium-menu02',
          name: '방문교육 (교통비 실비 별도)',
          price: 300000,
        },
      ],
    },
    {
      title: '배달앱관리',
      name: 'delivery_app',
      items: [
        {
          id: 'premium-deliveryApp01',
          name: '배달 앱 등록 (배민, 쿠팡, 요기요 등)',
          price: 100000,
        },
        {
          id: 'premium-deliveryApp02',
          name: '로고, 사진, 브랜드 제공',
          price: 0,
        },
        {
          id: 'premium-deliveryApp03',
          name: '배달앱 컨설팅 (리뷰이벤트, 깃발 등)',
          price: 200000,
        },
      ],
    },
    {
      title: '디자인물',
      name: 'design',
      items: [
        {
          id: 'premium-designApp01',
          name: '스티커, 메모지, 자석전단지',
          price: 100000,
        },
        {
          id: 'premium-designApp02',
          name: '간판',
          price: 500000,
        },
        {
          id: 'premium-designApp03',
          name: '외벽시트지',
          price: 200000,
        },
        {
          id: 'premium-designApp04',
          name: 'X 배너',
          price: 100000,
        },
      ],
    },
  ];

  // sales data
  private salesRequestDto = new SalesRequestDto();
  private salesResponseDto: any = new SalesResponseDto();

  // 반경내 추천메뉴
  private recommendMenuHdong = [];

  // 창업 업종
  private kbMediumCategories: KB_MEDIUM_CATEGORY[] = [
    ...CONST_KB_MEDIUM_CATEGORY,
  ];

  // 창업 유형
  private storeTypes: STORE_TYPE[] = [...CONST_STORE_TYPE];

  // 업종별 매출 비율
  private mediumCategoryRank = 0;
  private kbCategoryRevenueChartData = {
    datasets: [
      {
        backgroundColor: [
          '#00B1FF',
          '#79FEDD',
          '#4FD0E4',
          '#E4EBF2',
          '#C9D7E4',
          '#AFC3D7',
          '#AFC3D7',
          '#AFC3D7',
          '#AFC3D7',
          '#AFC3D7',
          '#AFC3D7',
        ],
      },
    ],
  };
  // 연령별
  get computedAgeRatio() {
    const obj = this.salesResponseDto.ageRatio;
    const arr = [];
    let newObj = {};
    for (const prop in obj) arr.push([prop, obj[prop]]);
    const temp = arr[4];
    arr.unshift(temp);
    const entries = new Map(arr);
    newObj = Object.fromEntries(entries);
    return newObj;
  }

  // 시갠대별
  get computedHourRevenueRatio() {
    const obj = this.salesResponseDto.hourRevenueRatio;
    const arr = [];
    let newObj = {};
    for (const prop in obj) arr.push([prop, obj[prop]]);
    const temp = arr[2];
    arr.unshift(temp);
    const entries = new Map(arr);
    newObj = Object.fromEntries(entries);
    return newObj;
  }

  // 주 소비층
  get computedMainGagu() {
    if (this.salesResponseDto.mainGagu === 1) {
      return '1~2인 가구';
    } else {
      return '3~4인 가구';
    }
  }

  // 주 연령대
  get computedMainAgeGroup() {
    if (this.salesResponseDto.mainAgeGroup === 2) {
      return '20~40대';
    } else {
      return '30~50대';
    }
  }

  // 주 소비층 차트
  private mainGaguChartData = {
    datasets: [
      {
        backgroundColor: [],
      },
    ],
  };

  get computedMainGaguBackgroundColor() {
    const arr = [];
    Object.values(this.salesResponseDto.gaguRatio).map((e, index) => {
      arr.push(
        `rgba(100,132,163, ${(index + 1) /
          Object.values(this.salesResponseDto.gaguRatio).length})`,
      );
    });
    return arr;
  }

  get computedMainGaguLabelColor() {
    const rankColorArr = ['#00B1FF', '#79FEDD', '#4FD0E4'];
    let colorData = [];
    let rankData = [];
    colorData = [...this.computedMainGaguBackgroundColor];
    if (this.salesResponseDto.mainGagu === 1) {
      rankData = [1, 2];
    } else {
      rankData = [3, 4];
    }
    colorData.map((e, index) => {
      colorData[rankData[index] - 1] = rankColorArr[index];
    });
    return colorData;
  }

  // 주 연령대 차트
  private mainAgeGroupChartData = {
    datasets: [
      {
        backgroundColor: [],
      },
    ],
  };

  get computedMainAgeGroupBackgroundColor() {
    const arr = [];
    Object.values(this.salesResponseDto.ageRatio).map((e, index) => {
      arr.push(
        `rgba(100,132,163, ${(index + 1) /
          Object.values(this.salesResponseDto.ageRatio).length})`,
      );
    });
    return arr;
  }

  get computedMainAgeGroupLabelColor() {
    const rankColorArr = ['#00B1FF', '#79FEDD', '#4FD0E4'];
    let colorData = [];
    let rankData = [];
    colorData = [...this.computedMainAgeGroupBackgroundColor];
    if (this.salesResponseDto.mainAgeGroup === 2) {
      rankData = [2, 3, 4];
    } else {
      rankData = [3, 4, 5];
    }
    colorData.map((e, index) => {
      colorData[rankData[index] - 1] = rankColorArr[index];
    });
    return colorData;
  }

  // 요일별 매출 비율 차트
  private maxRevenueWeekday: any = '';

  // 시간대별 매출 비율 차트
  private maxRevenueHour: any = '';

  // 매출 분석 차트
  private revenueChartData = {
    labels: ['', '최저매출', '평균매출', '최고매출', ''],
    datasets: [
      {
        pointRadius: [0, 5, 10, 5, 0],
        pointHoverRadius: [0, 5, 20, 5, 0],
        pointBackgroundColor: [
          'rgba(50,127,227,1)',
          'rgba(50,127,227,1)',
          'rgba(255,255,255,1)',
          'rgba(50,127,227,1)',
          'rgba(50,127,227,1)',
        ],
        borderWidth: 3,
      },
    ],
  };

  // 상권매출현황 차트
  private revenueData = [];

  // 성별 매출비중
  private mainGender: any = 0;

  // 배달의민족 상세현황
  private consultBaeminReport = new BaeminReportDto();

  // 지도 가져오기
  private map;
  private reportAddress = '';
  private consultResponseV3Dto = new ConsultResponseV3Dto();
  private mediumCategoryRevenueLabel = [];
  private mediumCategoryRevenueValue = [];

  getSalesData() {
    ConsultResponseV3Service.getSalesData(this.salesRequestDto).subscribe(
      res => {
        if (res) {
          this.salesResponseDto = res.data;

          if (this.salesResponseDto) {
            // 행정동 주소
            this.reportAddress = `${this.salesResponseDto.hdong.sidoName} ${this.salesResponseDto.hdong.guName} ${this.salesResponseDto.hdong.hdongName}`;

            // 행정동 추천 메뉴
            this.recommendMenuHdong = [
              ...Object.values(res.data.recommendMenuHdong),
            ];

            //상권매출현황 차트 데이터
            this.revenueData = [
              0,
              +this.salesResponseDto.minRevenue,
              +this.salesResponseDto.medianRevenue,
              +this.salesResponseDto.maxRevenue,
              parseInt(this.salesResponseDto.maxRevenue) +
                parseInt(this.salesResponseDto.maxRevenue) / 2,
            ];

            // 요일별 매출 분석
            const weekDayRatioObj = this.salesResponseDto.weekDayRevenueRatio;
            this.maxRevenueWeekday = Object.keys(weekDayRatioObj).reduce(
              (a: string, b: string) => {
                return weekDayRatioObj[a] > weekDayRatioObj[b] ? a : b;
              },
            );

            // 시간대별 매출 분석
            const maxHourRatioObj = this.salesResponseDto.hourRevenueRatio;
            this.maxRevenueHour = Object.keys(maxHourRatioObj).reduce(
              (a: string, b: string) => {
                return maxHourRatioObj[a] > maxHourRatioObj[b] ? a : b;
              },
            );

            // 성별 매출 분석
            const maxGenderRatioObj = this.salesResponseDto
              .mediumCategoryGenderRevenueRatio;
            this.mainGender = Object.keys(maxGenderRatioObj).reduce(
              (a: string, b: string) => {
                return maxGenderRatioObj[a] > maxGenderRatioObj[b] ? a : b;
              },
            );

            // 업종 매출 순위

            const mediumCategoryRevenueRatio = this.salesResponseDto
              .mediumCategoryRevenueRatio;

            let sortArr: any[] = [...Object.values(mediumCategoryRevenueRatio)];
            const keysArr = [...Object.keys(mediumCategoryRevenueRatio)];
            const findIdx = keysArr.findIndex(
              e => e === this.salesResponseDto.mediumCategoryCode,
            );
            const sorted = sortArr.slice().sort((a: number, b: number) => {
              return b - a;
            });
            sortArr = sortArr.slice().map(e => {
              return sorted.indexOf(e) + 1;
            });
            this.mediumCategoryRank = parseInt(sortArr[findIdx]);

            //kb 중분류 코드에서 한글로 변경
            const tempObj = {};
            const tempArr = [];
            Object.keys(mediumCategoryRevenueRatio).map(e => {
              tempObj[KB_MEDIUM_CATEGORY_KOREAN[e]] =
                mediumCategoryRevenueRatio[e];
            });

            Object.keys(tempObj).map(e => {
              tempArr.push({ categoryName: e, value: tempObj[e] });
            });

            tempArr.sort((a, b) => {
              return b.value - a.value;
            });
            this.mediumCategoryRevenueLabel = [];
            this.mediumCategoryRevenueValue = [];
            tempArr.map(e => {
              this.mediumCategoryRevenueLabel.push(e.categoryName);
            });
            tempArr.map(e => {
              this.mediumCategoryRevenueValue.push(e.value);
            });
            this.$set(
              this.salesResponseDto,
              'mediumCategoryRevenueRatio',
              tempObj,
            );
          }
          this.setMap();
        }
      },
    );
  }

  getConsultData(id) {
    ConsultResponseV3Service.findOne(id).subscribe(res => {
      if (res) {
        this.consultResponseV3Dto = res.data;
        if (res.data.consultBaeminReport) {
          const hdongCode = res.data.consultBaeminReport.hdongCode;
          this.salesRequestDto.hdongCode = hdongCode.toString();
          this.salesRequestDto.mediumCategoryCode =
            res.data.consultBaeminReport.mediumCategoryCode;
          this.getSalesData();
          this.getBaeminData();
        }
      }
    });
  }

  getBaeminData() {
    ConsultResponseV3Service.findOne(this.$route.params.id).subscribe(res => {
      if (res) {
        this.consultBaeminReport = res.data.consultBaeminReport;
      }
    });
  }

  // 지도 가져오기
  setMap() {
    const geocoder = new window.kakao.maps.services.Geocoder();

    const callback = function(result, status) {
      if (status === window.kakao.maps.services.Status.OK) {
        const mapContainer = document.getElementById('map');
        const mapOption = {
          center: new window.kakao.maps.LatLng(result[0].y, result[0].x),
          level: 5,
          minLevel: 3,
        };

        const map = new window.kakao.maps.Map(mapContainer, mapOption);

        const content = ``;
        const markerPosition = new window.kakao.maps.LatLng(
          result[0].y,
          result[0].x,
        );

        const customOverlay = new window.kakao.maps.CustomOverlay({
          position: markerPosition,
          content: content,
          // image: markerImage,
        });

        const circle = new window.kakao.maps.Circle({
          map: map,
          center: new window.kakao.maps.LatLng(result[0].y, result[0].x),
          strokeWeight: 2,
          strokeColor: '#477DE6',
          strokeOpacity: 1,
          strokeStyle: 'solid',
          fillColor: '#4CB0F8',
          fillOpacity: 0.3,
        });
        circle.setRadius(800);
        circle.setMap(map);
        customOverlay.setMap(map);
      }
    };

    geocoder.addressSearch(this.reportAddress, callback);
  }

  setAddress(res) {
    this.reportAddress = `${res.sido} ${res.sigungu} ${res.bname}`;
    const geocoder = new window.kakao.maps.services.Geocoder();
    const callback = (results, status) => {
      if (status === window.kakao.maps.services.Status.OK) {
        if (results[0]) {
          this.salesRequestDto.hdongCode = +results[0].address.h_code;
        }
      } else {
        toast.error('다른 주소로 선택해주세요');
      }
    };
    geocoder.addressSearch(res.address, callback);
    this.$bvModal.hide('postcode');
  }

  showAddressModal() {
    this.$bvModal.show('postcode');
  }

  goTop() {
    this.$nextTick(() => {
      // this.$refs.report.scrollTop = 0;
      const top = this.$refs.report.getBoundingClientRect().top;
      window.scrollTo(0, top);
    });
  }

  created() {
    const id = this.$route.params.id;
    this.getConsultData(id);
  }
}
